import * as React from "react";
import {
  Timeline,
  TimelineSeparator,
  TimelineConnector,
  TimelineDot,
  TimelineContent,
} from "@mui/lab";
import { PrimaryText, SecondaryText } from "../../styles/global";

import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";

const EducationTimeLine = [
  {
    title: "Master of Professional Studies in Analytics",
    value: "Current GPA: 4.0 / 4.0",
    institution: "Northeastern University - Toronto Campus",
    time: "September 2023 - On-going",
  },
  {
    title: "B.Tech Information Technology",
    value: "CGPA: 8.86",
    institution: "Navrachana University",
    time: "July 2019 - May 2023",
  },
  // {
  //   title: "Higher Secondary Education (PCM)",
  //   value: "Percentage: 76%",
  //   institution: "Urmi School",
  //   time: "July 2018 - May 2019",
  // },
  // {
  //   title: "Secondary Education",
  //   value: "CGPA: 8.6",
  //   institution: "Urmi School",
  //   time: "July 2016 - May 2017",
  // },
];

const Education = () => {
  return (
    <Timeline
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}
    >
      {EducationTimeLine.map((item, i) => {
        return (
          <TimelineItem key={i}>
            <TimelineSeparator>
              <TimelineDot variant="outlined" />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <PrimaryText bg={"#ff5757"}>{item.title}</PrimaryText>
              <SecondaryText>{item.institution}</SecondaryText>
              <SecondaryText>{item.time}</SecondaryText>
              <SecondaryText>{item.value}</SecondaryText>
            </TimelineContent>
          </TimelineItem>
        );
      })}
    </Timeline>
  );
};

export default Education;
